/**
 * Different Carousel arrows placement.
 * @public
 */
enum CarouselArrowsPlacement {
	/**
	 * Carousel arrows are placed on the sides of the current Carousel page.
	 * @public
	 */
	Content = "Content",

	/**
	 * Carousel arrows are placed on the sides of the page indicator of the Carousel.
	 * @public
	 */
	Navigation = "Navigation",
}

export default CarouselArrowsPlacement;
